export enum VehicleFeatures {
  ADD_VEHICLE,
  REPLACE_VEHICLE
}
